export enum SourceVideoType {
    WEBCAM = 'WEBCAM',
    SCREENCAST = 'SCREENCAST',
    VIRTUAL_SCREENCAST = 'VIRTUAL_SCREENCAST',
    UPLOAD = 'UPLOAD',
    AIAVATAR='AIAVATAR',
    VIDEO_SLIDE='VIDEO_SLIDE',
    SLIDE="SLIDE",
    SLIDE_HTML="SLIDE_HTML",
    NONE = 'NONE',
}
